import {Component, ElementRef, HostListener, inject, input, output} from '@angular/core';
import {ImagesService} from '../../../services/general/images.service';

interface ExportTypeConfig {
  icon: string;
  text: string;
}

type ExportType = 'Excel' | 'PDF' | 'CSV';

@Component({
  selector: 'app-export-button',
  imports: [],
  templateUrl: './export-button.component.html',
  styleUrl: './export-button.component.scss'
})
export class ExportButtonComponent {

  selected = input<string>();
  _images = inject(ImagesService);
  isShowOptions: boolean = false;
  onExportEvent = output<ExportType>()
  _eref = inject(ElementRef);

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    if (!this._eref.nativeElement.contains(event.target)) {
      this.isShowOptions = false;
    }
  }

  exportTypes: ExportType[] = ['Excel', 'PDF', 'CSV'];

  _image: Record<ExportType, ExportTypeConfig> = {
    Excel: {
      icon: 'icons/excel.svg',
      text: 'Export to Excel'
    },
    PDF: {
      icon: 'icons/pdf.svg',
      text: 'Export to PDF'
    },
    CSV: {
      icon: 'icons/csv.svg',
      text: 'Export to CSV'
    }
  };

  export(type: ExportType): void {
    this.isShowOptions = false;
    this.onExportEvent.emit(type);
  }

  showOptions(): void {
    this.isShowOptions = !this.isShowOptions;
  }
}
